import Enums from 'utils/EnumsManager';
const { DUPLICATES } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_DUPLICATES = DUPLICATES + 'SET_DUPLICATES';
export const SET_FIELDS = DUPLICATES + 'SET_FIELDS';
export const SET_FIELD = DUPLICATES + 'SET_FIELD';
export const SET_ROW_SELECTION = DUPLICATES + 'SET_ROW_SELECTION';
export const RESET = DUPLICATES + 'RESET';
export const TOGGLE_CHECKBOX = DUPLICATES + 'TOGGLE_CHECKBOX';



// WEBPACK FOOTER //
// ./src/components/page/FindDuplicates/flow/actionTypes.js